import { render } from "./TooltipMenu.vue?vue&type=template&id=3e072715&scoped=true"
import script from "./TooltipMenu.vue?vue&type=script&lang=js"
export * from "./TooltipMenu.vue?vue&type=script&lang=js"

import "./TooltipMenu.vue?vue&type=style&index=0&id=3e072715&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e072715"]])

export default __exports__